import { render, staticRenderFns } from "./LinksIgreja.vue?vue&type=template&id=2f29b524&scoped=true"
import script from "./LinksIgreja.vue?vue&type=script&lang=js"
export * from "./LinksIgreja.vue?vue&type=script&lang=js"
import style0 from "./LinksIgreja.vue?vue&type=style&index=0&id=2f29b524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f29b524",
  null
  
)

export default component.exports